import React from 'react';
import { ReactComponent as ArrowUpIcon } from '../../icons/svg/ic-top.svg';

export default class BackTop extends React.Component {
  onScrollTop() {
    this.props.scrollTop();
  }
  render() {
    return (
      <div className="back-top">
        <div className="back-top-container" onClick={() => this.onScrollTop()}>
          <div className="back-top-icon"><ArrowUpIcon></ArrowUpIcon></div>
          <div className="back-top-text">BACK TO TOP</div>
        </div>
      </div>
    );
  }

};
